<cm-overlay>
  <cm-setup
    title="Setup Error"
    subTitle="Unknown MAC Address: {{ macAddress }}"
    [showOk]="true"
    (okPressed)="onOk($event)"
  ></cm-setup>
</cm-overlay>
